import { TicketType } from '@nimey/podcast-global-entity';
import { useTranslation } from 'react-i18next';

export const TicketTypeLabel = ({type}: {type: TicketType}) => {
  const { t } = useTranslation('help');
  return <>{t('ticket.type.' + type)}</>
}